/* istanbul ignore file */
import { number as codecNumber, optional as codecOptional, string as codecString, } from 'purify-ts/Codec';
import { utils as coreUtils } from '@codegrade/api-core';
import { parsers } from '@codegrade/utils';
import { CommentReplyType } from './CommentReplyType';
const CreateCommentReplyDataParser = 
/* #__PURE__ */ parsers.object([
    ['comment', codecString],
    [
        'inReplyTo',
        /* #__PURE__ */ codecOptional(/* #__PURE__ */ parsers.maybeNull(codecNumber)),
        'in_reply_to',
    ],
    ['replyType', CommentReplyType, 'reply_type'],
]);
export class CreateCommentReplyData extends /* #__PURE__ */ coreUtils.AssigningBase {
    static decode(input) {
        return CreateCommentReplyDataParser.decode(input).map(res => new CreateCommentReplyData(res));
    }
    static unsafeDecode(input) {
        return CreateCommentReplyData.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return CreateCommentReplyDataParser.encode(data);
    }
    static schema() {
        return CreateCommentReplyDataParser.schema();
    }
}
